module.exports = __webpack_public_path__ + "static/media/small-info-icon.a4649661.svg";